<template>
    <div>
        <div class="clearfix">
            <Form :labelWidth="120" class="clearfix">
                <Col span="12">
                    <FormItem :label="$t('fbb.inbound.purchase_order_no', { defaultValue: '采购单号' })">
                        <Select v-if="inputtype!='modifytype'" clearable filterable multiple v-model="orderNo" ref="zierpselect" remote :remote-method="remoteMethod1" :loading="loading1" :placeholder="$t('fbb.inbound.input_purchase_no_query', { defaultValue: '输入采购单号查询' })">
                            <Option v-for="json in purchaseList" :value="json" :key="json">{{ json}}</Option>
                        </Select>
                        <div  v-else>
                            <vInput v-model="poNosList" disabled="true"></vInput>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <vButton class="margin-left-10" v-if="inputtype!='modifytype'" theme="primary" @click="search">{{$t('global.common.btn_search', { defaultValue: '查询' })}}</vButton>
                    <vButton class="margin-left-10" v-if="inputtype!='modifytype'" @click="clearbox">{{$t('global.common.clear', { defaultValue: '清空' })}}</vButton>
                    <vButton class="margin-left-10" theme="success" @click="importExcel">{{$t('global.common.import', { defaultValue: '导入' })}}</vButton>
                </Col>
            </Form>
            <vCol span="24">
                <vTable
                    class="margin-15"
                    :columns="columns" 
                    :data="datalist"
                    size="small" 
                    ref="tabledoc"  
                    border
                > </vTable>
            </vCol>
            <div class="text-right">
                <vButton theme="primary" @click="submit">{{$t('global.common.update_OK', { defaultValue: '确定' })}}</vButton>
                <vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
            </div>
        </div>
        <vModal
			class="hidefooter"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
		>
			<compUpload
                v-bind="getFileProps"
				@on-success="aaasuccess"
				@on-cancel="cancelUpload"
			/>
			<footer slot="footer" v-show="false"></footer>
		</vModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import {HttpPurchaseNoList,HttpPurchaseDetail,HttpSavePurchaseList} from '@/service/headlogistics';
import { HttpSaveInboundPoItems } from '@/service/inbound';

export default {
    props:['inboundList','poNosList','inputtype','orderid'],
    components: {
        compUpload: () =>  import("@components/templates/upload"),
	},
    data(){
        return {
            orderNo:'',
            loading1:false,
            loading:false,
            purchaseList:[],
            datalist:[],
            id: this.$route.query.id || this.orderid,
            pushpurchase:[],
            operate:{
				id: null,
				title: "",
                show: false,
                actionurl:'',
                downexcel:'',
				component: null
			},
        }
    },
    mounted(){
        this.update()
    },
    computed:{
        getFileProps(){
            return {
                data: {
                   /*  poNoList:(this.orderNo || []).join(','), */
                    inboundPlanOrderId:this.id || '',
                },
                action: process.env.VUE_APP_APIURL_FBB + this.operate.actionurl,
                name: "excelFile",
                download:()=>{
                    this.handleWebfs(this.operate.downexcel, {}, {
                        executor: 'download',
                        type: 'url'
                    });
                },
            }
        },
        columns(){
            return [
                {
                    title: "No.",
                    type: 'index',
                    width: 60,
                }, {
                    title: this.$t('fbb.inbound.purchase_order_no', { defaultValue: '采购单号' }),
                    key: 'poNo'
                }, {
                    title: "SKU",
                    key: 'sku'
                }, {
                    title: this.$t('fbb.inbound.purchase_number', { defaultValue: "采购数量/可用数量" }),
                    render:(h,{row})=>{
                        return <div>{row.poQty}/{row.availableQty}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.plan_shipment_number', { defaultValue: "计划发运数量" }),
                    render:(h,{row,index})=>{
                        return h('vInputNumber',{
                            props: {
                                size:'small',
                                value:row.planShipQty || 0,
                                min:0,
                            },
                            on: {
                                'input':(event) => {
                                    row.planShipQty = event 
                                    this.datalist[index] = row
                                }
                            },
                        })
                    }
                },
            ]
        }
    },
    methods:{
        // 点击导入按钮
        importExcel(){
            /* if(this.datalist.length<1){
                this.$VMessage.error(this.$t('fbb.inbound.choose_purchase_first', { defaultValue: '请先选择采购单并查询！' }))
            }else{ */
                this.operate = {
                    show: true,
                    title: this.$t('global.common.import', { defaultValue: '导入' }),
                    actionurl:'/api/v2/Inbound/importPoItems',
                    downexcel:"/static/template/import_purchase.xlsx",
                };
            /* } */
            
        },
        aaasuccess(res){
            this.datalist = res.data
            this.cancelUpload()
        },
        cancelUpload(){
            this.operate.show = false
        },
        update(){
            // console.log(this.inboundList)
            if(this.inboundList){
                this.datalist = this.inboundList
            }
            this.pushpurchase = this.poNosList.split(",")
        },
        remoteMethod1(query){
            HttpPurchaseNoList({'search[CN_orderNo]':query,rows:10,'search[EQ_orderStatus]':'auditing_pass','search[IN_inboundAvailable]':[0,2]}).then(res=>{
                this.purchaseList = res.data.content.map(item=>{
                    return item.orderNo
                })
                this.purchaseList.push(...this.pushpurchase)
                this.purchaseList = Array.from(new Set(this.purchaseList))
            },err=>{
                this.$vMessage.error(err.message);
            })
        },
        search(){
            HttpPurchaseDetail({
                poOrderNos:this.orderNo,
                inboundPlanOrderId:this.id,
            }).then(res=>{
                // console.log(res)
                this.datalist = res.data
            },err=>{
                this.$vMessage.error(err.message);
            })
        },
        clearbox(){
            this.orderNo = ''
            this.datalist = []
        },
        submit(){
            
            let flag = false
            this.datalist.map(item=>{
                if(Number(item.planShipQty)>Number(item.availableQty)){
                    flag = true
                }
            })

            if(flag){
                this.$VMessage.error(this.$t('fbb.inbound.error_shipment_lt_useful', { defaultValue: '发运数量填写不能大于可用数量' }))
                return
            }
            this.loading = true;
            if(this.inputtype!='modifytype'){
                HttpSavePurchaseList({
                    inboundPlanOrderPoItemModelList:this.datalist
                }).then(res=>{
                    let data = {
                        tablelist:this.datalist,
                        content:res.data.inboundPlanOrderItemModelList,
                        orderNo:res.data.poNos,
                        newData:res.data,
                    }
                    this.$emit('on-purchase',data);
                    this.$emit('on-close');
                    this.loading = false;
                },err=>{
                    this.loading = false;
                    this.$VMessage.error(err.message);
                })
            }else{
                HttpSaveInboundPoItems({
                    inboundPlanOrderId:this.id,
                    inboundPlanOrderPoItemModelList:this.datalist
                }).then(res=>{
                    this.$emit('on-updatepro');
                    this.$emit('on-close');
                    this.loading = false;
                },err=>{
                    this.loading = false;
                    this.$VMessage.error(err.message);
                })
            }
            
        },
        cancel(){
            this.$emit('on-close')
        },
    },
}
</script>





